import Loading from "@/components/Loading";
import { CardContent } from "@/components/ui/card";

export function InvitationLoadingCard() {
  return (
    <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
      <Loading className="h-8 w-8 text-primary" />
      <p className="text-gray-600">Loading your invitation…</p>
    </CardContent>
  );
}
